import React from "react";
/** Services Import */
import Commons from "./services/Common/Common";
import IndexedDb from "./services/IndexedDb/IndexedDb";
import * as util from "./utill";
/** Components Import */
import Routers from "./Routers/Router";
import { ToastContainer } from "react-toastify";
/** Styles Import */
import "./Styles/App.css";
import "./Styles/Common.css";
import "react-toastify/dist/ReactToastify.css";
/** FCM Import */
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

function App() {
  let firebaseSupported = false;
  let firebaseMessaging = null;
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };
  const firebase = initializeApp(firebaseConfig);
  const meta = document.createElement("meta");
  meta.name = "viewport";
  meta.content = "width=device-width, initial-scale=1";
  document.getElementsByTagName("head")[0].appendChild(meta);

  isSupported().then((result) => {
    firebaseSupported = result;
    if (result) {
      firebaseMessaging = getMessaging(firebase);

      util.getPermission();
      onMessage(firebaseMessaging, (payload) => {
        // console.log("Message received. ", payload);
        Commons.Toast("info", () => (
          <div>
            {`[ ${payload.notification.title} ]`}
            <br />
            {payload.notification.body}
          </div>
        ));
      });
    }
  });

  IndexedDb.CreateIndexedDB();
  Commons.Storages("set", "version", {
    version: "v1.1.23-alpha",
  });
  if (!Commons.Storages("get", "authorization")) {
    Commons.Storages("set", "authorization", {
      authorization: false,
      authDate: Commons.DateFormating(new Date()),
    });
  }
  if (!Commons.Storages("get", "saves")) {
    Commons.Storages("set", "saves", {
      company: "",
      userId: "",
      password: "",
      saves: false, // 로그인 Input 저장 여부
      busNo: "", // 즐겨찾기한 버스 번호 저장
      routeId: "",
      reloadTime: "30", // 자동배차 자동 새로고침 초
    });
  }
  // if (!Commons.Storages("get", "fcmServices")) {
  //   Commons.Storages("set", "fcmServices", {
  //     token: "",
  //     date: "",
  //     time: "",
  //   });
  // }

  return (
    <div className='App'>
      <Routers />
      <ToastContainer />
    </div>
  );
}

export default App;
